export default async function auth({next, router, store}) {
  if (!store.getters.isAuthenticated && !store.state.getAccessToken) {
    try {
      const data = await store.dispatch('fetchUser')
      if(data) {
        next()
      } else {
        router.push('/session/login')
      }
    } catch (e) {
      router.push('/session/login')
    }
  } else {
    return next();
  }
}
